import type { ProcessEngineTask } from '../../../../enum';

export enum ConfirmationLevel {
    LOW = 'LOW',
    HIGH = 'HIGH',
}

export interface IBsiBusinessRelationshipConfirmationInput {
    accountNr?: string; // maxLength=22 (KT_LNR)
    shippingAddress: string; // maxLength=250
    targetDate: string; // yyyy-mm-dd, Stichdatum
    customerNrs: string[]; // (KD_LNR)[]
    levelOfDetailType: ConfirmationLevel;
    notes?: string; // maxLength = 250, Freitext
}

export interface IBsiBusinessRelationshipConfirmationTask {
    taskType: ProcessEngineTask.CONFIRM_BUSINESS_RELATIONSHIP;
    BsiCaseInput: IBsiBusinessRelationshipConfirmationInput;
}
